const CardUsuariosAtivos = (props) => {
  return (
    <article className="card">
      <div className="card-header">
        <div className="card-title">
          <span>✅</span>
          <span>Ativos x Inativos</span>
        </div>
      </div>
      <div className="card-body">
        <div>
          <strong>Ativos:</strong> <span id="totalAtivos">{props.ativos}</span>
        </div>
        <div>
          <strong>Inativos:</strong> <span id="totalInativos">{props.inativos}</span>
        </div>
        <div className="card-sub">{props.subtitle || "Status de licenciados."}</div>
      </div>
    </article>
  );
};

export default CardUsuariosAtivos;
